import React, { Component, Fragment } from 'react';
import ClassNames from 'classnames';
import Checkbox from 'Components/Checkbox';
import {ReactComponent as DownArrow} from 'Icons/downArrow.svg';

class GroupContainer extends Component {
    constructor(props){
        super(props);
        this.state = {
            isTransportersShown: true
        }
    }

    toggleTransporters = () => {
        const { isTransportersShown } = this.state;
        this.setState({
            isTransportersShown: !isTransportersShown
        })
    }
    render() {
        const { group, selectedTransporters, isSelected } = this.props;
        const isGroup = (selectedTransporters || []).find(sel => sel.id === group.id);
        const transporterSelected = isGroup && isGroup.transporters && (isGroup.transporters).map(trans => trans.id) || [];
        
        return (
            <Fragment>
                <div className={ClassNames("bg-theme-light ht-40 fs-16 fSemibold flex flex-middle flex-between mt-20", {
                    
                })}>
                    <DownArrow onClick={this.toggleTransporters} className={ClassNames("ml-10", {
                        'rotate-180': this.state.isTransportersShown,
                        'rotate-0': !this.state.isTransportersShown
                    })}/>
                    <div className="pl-20 flex-1 row-100 flex flex-middle pr-15">
                        <div className="curP" onClick={this.toggleTransporters}>{group.name}</div> 
                    </div>
                    {!isSelected && <Checkbox 
                        type='square' 
                        onCheck={this.props.toggleAllTransporters} 
                        disabled={this.props.autoSelectTransporters} 
                        checked={isGroup && isGroup.transporters.length === group.transporters.length}
                    />}
                </div>
                <div className={ClassNames("height-transition box-shadow br-5", {
                    'disabled curNA': this.props.autoSelectTransporters
                })}
                // style={{
                //     overflowY: 'hidden',
                //     height: 40*(group.transporters.length)*(this.state.isTransportersShown?1:0)
                // }}
                >
                    {
                        group.transporters.map((transporter, index)=> {
                            return (
                                <div key={index} className="flex pv-5 fs-16 fSemibold flex flex-middle pl-40 flex-between">
                                    <label className="wt-87p mr-10" htmlFor={"group-transporter" + group.id + transporter.id}>
                                        {transporter.name}
                                    </label>
                                    {!isSelected && <Checkbox type='square' id={"group-transporter" + group.id + transporter.id} onCheck={()=> {
                                        this.props.toggleTransporter(transporter, group);
                                    }}
                                    checked={transporterSelected.indexOf(transporter.id) > -1}
                                    />}
                                </div>
                            )
                        })
                    }
                </div>
            </Fragment>
        )
    }
}

export default GroupContainer;